export default "__VITE_ASSET__22aa545a__"